<template>
  <div class="not-found-page">
    <div class="not-found-content">
      <div class="error-code">404</div>
      <div class="error-icon">
        <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#C00513" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h1 class="error-title">内容已经找不到了</h1>
      <p class="error-desc">您访问的内容可能已被删除、下架或输入的链接有误</p>
      <div class="error-actions">
        <router-link to="/" class="home-btn">返回首页</router-link>
        <span class="back-link" @click="goBack">返回上一页</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.not-found-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f8f8;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.not-found-content {
  text-align: center;
  padding: 60px 40px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
  max-width: 520px;
  width: 90%;
}

.error-code {
  font-size: 120px;
  font-weight: 700;
  color: #C00513;
  line-height: 1;
  letter-spacing: 4px;
  margin-bottom: 8px;
  text-shadow: 0 4px 20px rgba(192, 5, 19, 0.15);
}

.error-icon {
  margin-bottom: 24px;
}

.error-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0 0 12px;
}

.error-desc {
  font-size: 15px;
  color: #999;
  line-height: 1.6;
  margin: 0 0 32px;
}

.error-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

.home-btn {
  display: inline-block;
  padding: 12px 32px;
  background: #C00513;
  color: #fff;
  font-size: 15px;
  border-radius: 6px;
  text-decoration: none;
  transition: all 0.2s ease;
}

.home-btn:hover {
  background: #a00410;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(192, 5, 19, 0.25);
}

.back-link {
  font-size: 15px;
  color: #666;
  cursor: pointer;
  transition: color 0.2s;
}

.back-link:hover {
  color: #C00513;
}
</style>
